import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { routerStoreSelector } from '../router.selector';

export const locationSelector = createCachedSelector(
  [
    path(routerStoreSelector).location(),
  ],
  (location) => {
    return location;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
